import { Component } from '@angular/core';
import { Skeleton } from 'excellence-ui';

@Component({
  selector: 'app-supplier-contract-price-table-skeleton',
  imports: [Skeleton],
  templateUrl: './supplier-contract-price-table-skeleton.html',
})
export class SupplierContractPriceTableSkeleton {}
